import { FC, useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { Redirect, Route } from "react-router-dom";

import Login from './pages/authentication/Login'
import Register from './pages/authentication/Register'
import RegisterPendingReview from './pages/authentication/RegisterPendingReview'
import RegisterDomainExists from './pages/authentication/RegisterDomainExists'
import './utils/yupAugment'
import ActivateAccount from './pages/authentication/ActivateAccount';
import Dashboard from './pages/Dashboard';
import { CoreAdminUI, Resource, useAuthProvider } from 'ra-core';
import Layout from './pages/layout/Layout'
import ProfileCreate from './pages/profile/Create';
import OrganizationProfileCreate from './pages/settings/organization/OrganizationProfile/Create';
import OrganizationProfileUpdate from './pages/settings/organization/OrganizationProfile/Update';
import SsoConfig from './pages/settings/organization/SsoConfig/Update';
import DataAccessPolicy from './pages/settings/encryption/DataAccessPolicy/List'
import CatchAllUndefinedRoute from './components/CatchAllUndefinedRoute';
import ProfileUpdate from './pages/profile/Update';
import PasswordChange from './pages/authentication/PasswordChange';
import { OrganizationSettingsComposite } from './pages/settings/organization/OrganizationSettingsComposite';
import Users from './pages/settings/organization/Users/List';
import InvitationConfirm from './pages/authentication/InvitationConfirm';
import RegistrationOnlyResource from './components/RegistrationOnlyResource';
import SsoRedirect from './pages/authentication/SsoRedirect';
import PasswordRecovery from './pages/authentication/PasswordRecovery';
import PasswordRecoverySent from './pages/authentication/PasswordRecoverySent';
import ResetPasswordCollect from './pages/authentication/ResetPasswordCollect';
import OdResource from './components/recource/OdResource';
import BackupResourceRegister from './pages/backups/BackupResourceRegister';
import BackupValidationList from './pages/backups/BackupValidationList';
import BackupValidationDetail from './pages/backups/BackupValidationDetail';
import BackupValidationDashboard from './pages/backups/BackupValidationDashboard';
import DatabaseDetail from './pages/databases/DatabaseDetail';
import SimpleComposite from './components/recource/SimpleComposite';
import DatabaseResourceRegister from './pages/databases/DatabaseResourceRegister';
import EncryptionDashboard from './pages/obfuscation/EncryptionDashboard';
import CreateCustomRule from './pages/obfuscation/CreateCustomRule';
import CustomRuleList from './pages/obfuscation/CustomRuleList';
import EditCustomRule from './pages/obfuscation/EditCustomRule';
import EditEncryptionMappings from './pages/obfuscation/EditEncryptionMappings';
import EncryptionDetail from './pages/obfuscation/EncryptionDetail';
import EncryptionList from './pages/obfuscation/EncryptionList';
import EncryptionMappings from './pages/obfuscation/EncryptionMappings';
import EncryptionDashboardResourceRegister from './pages/obfuscation/EncryptionDashboardResourceRegister';
import DeploymentDashboard from './pages/deployment/DeploymentDashboard';
import GovernanceDashboard from './pages/governance/GovernanceDashboard';
import GovernanceResourceRegister from './pages/governance/GovernanceResourceRegister';
import DeploymentDetail from './pages/deployment/DeploymentDetail';
import DeploymentList from './pages/deployment/DeploymentList';
import CustomerAgreement from './components/authentication/CustomerAgreement';
import PrivacyNotice from './components/authentication/PrivacyNotice';
import DocumentsLanding from './pages/documents/DocumentsLanding';
import NetworkConfigurationList from './pages/deployment/NetworkConfigurationList';
import NetworkConnectionDetail from './pages/deployment/NetworkConnectionDetail';
import PerformanceTuningDashboard from './pages/performance/PerformanceTuningDashboard';
import SecureFileDashboard from './pages/securefiles/SecureFileDashboard';
import SecureFileDetail from './pages/securefiles/FileDetail';
import SecureFileCatalog from './pages/securefiles/FileCatalog';
import SecureFileAccessLogs from './pages/securefiles/FileAccessLogs';
import SecureFilesResourceRegister from './pages/securefiles/SecureFilesResourceRegister';
import DataClassifications from './pages/settings/governance/DataClassifications';
import DataAccessRoleList from './pages/settings/governance/DataAccessRoleList';
import DataAccessRoleDetail from './pages/settings/governance/DataAccessRoleDetail';
import CreateDataAccessRole from './pages/settings/governance/CreateDataAccessRole';
import DataCatalog from './pages/governance/DataCatalog';
import DatabaseKeysPolicy from './pages/databases/DatabaseKeysPolicy';
import NotificationSettings from './pages/settings/notification/NotificationSettings';
import { EncryptionSettingsComposite } from './pages/settings/encryption/EncryptionSettingsComposite';
import { GovernanceSettingsComposite } from './pages/settings/governance/GovernanceSettingsComposite';
import UpdateEncryptionMappings from './pages/obfuscation/UpdateEncryptionMappings';
import EncryptionMappingsResourceRegister from './pages/obfuscation/EncryptionMappingsResourceRegister';
import DataOwnerGroupList from './pages/settings/governance/DataOwnerGroupList';
import DataOwnership from './pages/governance/DataOwnership';
import EditTablesOwnership from './pages/governance/EditTablesOwnership';
import CloudSubscriptionUpdate from './pages/settings/organization/CloudSubscription/Update';
import ObfuscationRuleList from './pages/settings/encryption/ObfuscationRule/ObfuscationRuleList';
import ObfuscationMappingList from './pages/obfuscation/ObfuscationMappingList';
import EditObfuscationMappings from './pages/obfuscation/EditObfuscationMappings';
import ObfuscationDetail from './pages/obfuscation/ObfuscationDetail';
import ObfuscationList from './pages/obfuscation/ObfuscationList';
import Device from './pages/authentication/Device';
import DeviceConsent from './pages/authentication/DeviceConsent';
import ClientManage from './pages/settings/organization/Clients/List';
import IpWhitelist from './pages/settings/organization/IpWhitelist/List';
import DatabaseEncryptionSettingChange from './pages/databases/DatabaseEncryptionSettingChange';
import FileTemplateDetail from './pages/obfuscation/FileTemplateDetail';
import { EncryptionComposite } from './pages/obfuscation/EncryptionComposite';
import KeyContent from './pages/settings/encryption/keys/KeyContent';
import DbSubsettingDetail from './components/obfuscation/DbSubsettingDetail';
import { Permissions_new } from './constants';
import { getSettingsMenuDefaultRoute } from './authProvider/permissionMap';
import { SecureFileComposite } from './pages/securefiles/SecureFileComposite';
import OfflineFileSearch from './pages/securefiles/OfflineFileSearch';
import ClassificationRules from './pages/securefiles/ClassificationRules';
import CreateClassificationRule from './pages/securefiles/CreateClassificationRule';
import DataProtectionRules from './pages/securefiles/DataProtectionRules';
import CreateDataProtectionRule from './pages/securefiles/CreateDataProtectionRule';


const withNoLayout: any = { noLayout: true }

const customRouts = [
  <Route path="/register" component={Register} {...withNoLayout} />,
  <Route path="/register-success" component={RegisterPendingReview} {...withNoLayout} />,
  <Route path="/register-domain-exists" component={RegisterDomainExists} {...withNoLayout} />,
  <Route path="/register-confirm" component={ActivateAccount} {...withNoLayout} />,
  <Route path="/invitation-confirm" component={InvitationConfirm} {...withNoLayout} />,
  <Route path="/sso-redirect" component={SsoRedirect} {...withNoLayout} />,
  <Route path="/change-password" component={PasswordChange} />,
  <Route path="/reset-password" component={PasswordRecovery} {...withNoLayout} />,
  <Route path="/reset-password-sent" component={PasswordRecoverySent} {...withNoLayout} />,
  <Route path="/reset-password-confirm" component={ResetPasswordCollect} {...withNoLayout} />,
  <Route path="/customer-agreement" component={CustomerAgreement} {...withNoLayout} />,
  <Route path="/privacy-notice" component={PrivacyNotice} {...withNoLayout} />,
  <Route path="/device" component={Device} {...withNoLayout} />,
  <Route path="/device-consent" component={DeviceConsent} {...withNoLayout} />,

  <Route path="/documents" component={DocumentsLanding} />,
  <Route path="/dashboard" component={() => <Redirect to="/" />} />,
]
const headBreadcrumbs = [{label:'Dashboard', path:'/dashboard'}]

const AppRoutes: FC = () => {
  const authProvider = useAuthProvider()
  const [permissions, setPermissions] = useState([] as Permissions_new[])
  useEffect(() => {
    (async () => {
      const permissions_1: Permissions_new[] = await authProvider.getPermissions(0)
      setPermissions(ps => {
        return (ps.length === 0 && permissions_1.length > 0 
          ? permissions_1 : ps)
      })
    })();
    authProvider.userManager.events.addUserLoaded(async () => {
      const permissions_1: Permissions_new[] = await authProvider.getPermissions(0)
      setPermissions(ps => {
        if (JSON.stringify(ps) !== JSON.stringify(permissions_1)) {
          return permissions_1
        } else {
          return ps
        }
      })
    })
  }, [authProvider])


  return useMemo(() => { return (
    <CoreAdminUI
      catchAll={CatchAllUndefinedRoute}
      customRoutes={customRouts}
      disableTelemetry={true}
      layout={Layout}
      loginPage={Login}
      dashboard={Dashboard}
    >
      <RegistrationOnlyResource name="_registration_only_" />
      <Resource name="profile" options={{label:'User Profile', breadcrumbs:headBreadcrumbs}}
        create={ProfileCreate}
        edit={ProfileUpdate}
      />
      <OrganizationSettingsComposite name="settings/organization" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}}
        fallbackTo={getSettingsMenuDefaultRoute("Organization", permissions) ?? "/settings/organization/profile/edit"}
      >
        <Resource name="settings/organization/profile" 
          options={{
            label: 'Organization Profile',
            breadcrumbs: headBreadcrumbs,
            primaryPath: '/settings/organization/profile/edit',
          }} 
          create={OrganizationProfileCreate}
          edit={OrganizationProfileUpdate}
        />
        <Resource name="settings/organization/user-manage" options={{label: 'Users' , breadcrumbs:headBreadcrumbs}} 
          list={Users}
        />
        <Resource name="settings/organization/clients" options={{label: 'Clients' , breadcrumbs:headBreadcrumbs}} 
          list={ClientManage}
        />
        <Resource name="settings/organization/sso-config" options={{label: 'SSO Configuration' , breadcrumbs:headBreadcrumbs}} 
          list={SsoConfig}
        />
        <Resource name="settings/organization/cloud-subscription" options={{label: 'Cloud Subscription' , breadcrumbs:headBreadcrumbs}} 
          list={CloudSubscriptionUpdate}
        />
        <Resource name="settings/organization/ip-whitelist" options={{label: 'IP Whitelist' , breadcrumbs:headBreadcrumbs}} 
          list={IpWhitelist}
        />
      </OrganizationSettingsComposite>
      <Resource name="settings/notification" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}} 
        list={NotificationSettings}
      />
      <EncryptionSettingsComposite name="settings/encryption" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}} 
        fallbackTo={getSettingsMenuDefaultRoute("Encryption", permissions) ?? "/settings/encryption/keys"}
      >
        <Resource name="settings/encryption/keys"
          options={{ label: 'Keys', breadcrumbs: headBreadcrumbs, }}
          list={KeyContent}
        />
        <Resource name="settings/encryption/tokens" 
          options={{label: 'Tokens' , breadcrumbs:headBreadcrumbs}} 
          list={DataAccessPolicy}
        />
        <Resource name="settings/encryption/obfuscation-rule"
          options={{ label: 'Obfuscation Rule', breadcrumbs: headBreadcrumbs, }}
          list={ObfuscationRuleList}
        />
      </EncryptionSettingsComposite>
      <GovernanceSettingsComposite name="settings/governance" options={{label: 'Settings' , breadcrumbs:headBreadcrumbs}} 
        fallbackTo={getSettingsMenuDefaultRoute("Data Access Policy", permissions) ?? '/settings/governance/data-classification'}
      >
        <Resource name="settings/governance/data-classification"
          options={{ label: 'Data Classification' }}
          list={DataClassifications}
        />
        <Resource name="settings/governance/data-access-role"
          options={{
            label: 'Data Access Roles',
          }}
          list={DataAccessRoleList}
          show={DataAccessRoleDetail}
          create={CreateDataAccessRole}
        />
        <Resource name="settings/governance/data-owner-group"
          options={{ label: 'Data Owner Group' }}
          list={DataOwnerGroupList}
        />
      </GovernanceSettingsComposite>
      <SimpleComposite name="settings/deployment" fallbackTo="/settings/deployment/network-configuration">
        <Resource name="settings/deployment/network-configuration"
          options={{
            label: 'Network Configuration',
            breadcrumbs: headBreadcrumbs,
          }}
          list={NetworkConfigurationList}
          show={NetworkConnectionDetail}
        />
      </SimpleComposite>
      <Resource name="settings"
        list={() => <Redirect to="/settings/organization/profile/edit" />}
      />

      <SimpleComposite name="backups-n-validations" fallbackTo="/backups-n-validations/dashboard">
        <OdResource name="backups-n-validations/list" 
          options={{
            label: 'Backups and Validations', 
            breadcrumbs: [
              { label: 'Data Continuity Dashboard', path: '/backups-n-validations' }
            ],
          }} 
          resourceRegister={BackupResourceRegister}
          list={BackupValidationList}
          show={BackupValidationDetail}
        />
        <Resource name="backups-n-validations/dashboard" options={{label: 'Backups and Validations'}} 
          list={BackupValidationDashboard}
        />
      </SimpleComposite>

      <SimpleComposite name="databases" fallbackTo="/dashboard">
        <Resource name="databases/:id/keys-policy"
          options={{
            label: 'Data Access Policy', 
            breadcrumbs: headBreadcrumbs,
          }} 
          list={DatabaseKeysPolicy}
        />
        <Resource name="databases/:id/encryption-setting-change"
          options={{
            label: 'Encryption Setting Change', 
            breadcrumbs: headBreadcrumbs,
          }} 
          list={DatabaseEncryptionSettingChange}
        />
        <OdResource name="databases" 
          options={{
            label: 'Database', 
            breadcrumbs: headBreadcrumbs,
          }} 
          resourceRegister={DatabaseResourceRegister}
          show={DatabaseDetail}
          list={Box}
        />
      </SimpleComposite>
      
      <EncryptionComposite name="encryption" fallbackTo="/encryption/dashboard">
        <Resource name="encryption/mappings/:dbId/update" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          list={UpdateEncryptionMappings}
        />
        <OdResource name="encryption/mappings" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          resourceRegister={EncryptionMappingsResourceRegister}
          edit={EditEncryptionMappings as any}
          list={EncryptionMappings}
        />
        <Resource name="encryption/file-mappings" 
          options={{
            label: 'Encryption Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={FileTemplateDetail as any}
          list={() => <Redirect to="/encryption/mappings" />}
        />
        <Resource name="encryption/obfs/mappings" 
          options={{
            label: 'Obfuscation Mappings',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          edit={EditObfuscationMappings as any}
          list={ObfuscationMappingList}
        />
        <Resource name="encryption/obfs/list"
          options={{
            label: 'Database Obfuscations',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={ObfuscationDetail}
          list={ObfuscationList}
        />
        <Resource name="encryption/list"
          options={{
            label: 'Database Encryptions',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={EncryptionDetail}
          list={EncryptionList}
        />
        <Resource name="encryption/subsetting/mastertables"
          options={{
            label: 'Database Encryptions',
            breadcrumbs: [
              { label: 'Encryption Dashboard', path: '/encryption/dashboard' }
            ],
          }}
          show={DbSubsettingDetail}
          list={() => <Redirect to="/encryption/dashboard" />}
        />
        <Resource name="encryption/custom-rules"
          create={CreateCustomRule}
          edit={EditCustomRule}
          list={CustomRuleList}
        />
        <OdResource name="encryption/dashboard"
          resourceRegister={EncryptionDashboardResourceRegister}
          list={EncryptionDashboard}
        />
      </EncryptionComposite>

      <SimpleComposite name="deployments" fallbackTo="/deployments/dashboard">
        <Resource name="deployments/list"
          options={{
            label: 'Database Deployments',
            breadcrumbs: [
              { label: 'Deployment Dashboard', path: '/deployments/dashboard' }
            ],
          }}
          list={DeploymentList}
          show={DeploymentDetail}
        />
        <Resource name="deployments/dashboard"
          list={DeploymentDashboard}
        />
      </SimpleComposite>

      <SimpleComposite name="governance" fallbackTo="/governance/dashboard">
        <OdResource name="governance/dashboard"
          resourceRegister={GovernanceResourceRegister}
          list={GovernanceDashboard}
        />
        <Resource name="governance/data-catalog" 
          options={{
            label: 'Data Catalog',
            breadcrumbs: [
              { label: 'Data Catalog Dashboard', path: '/governance/dashboard' }
            ],
          }}
          list={DataCatalog}
        />
        <Resource name="governance/data-ownership" 
          options={{
            label: 'Data Ownership',
            breadcrumbs: [
              { label: 'Data Catalog Dashboard', path: '/governance/dashboard' }
            ],
          }}
          list={DataOwnership}
          show={EditTablesOwnership}
        />
      </SimpleComposite>
      
      <SecureFileComposite name="secure-files" fallbackTo="/secure-files/dashboard">
        <OdResource name="secure-files/dashboard"
          resourceRegister={SecureFilesResourceRegister}
          list={SecureFileDashboard}
        />
        <Resource name="secure-files/file-catalog" 
          options={{
            label: 'File Catalog',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={SecureFileCatalog}
        />
        <Resource name="secure-files/file-access-log" 
          options={{
            label: 'File Access Logs',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={SecureFileAccessLogs}
          />
        <Resource name="secure-files/offline-files" 
          options={{
            label: 'Offline Files',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={OfflineFileSearch}
          />
        <Resource name="secure-files/classification-rules" 
          options={{
            label: 'Classification Rules',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          create={CreateClassificationRule}
          list={ClassificationRules}
          />
        <Resource name="secure-files/data-protection-rules" 
          options={{
            label: 'Data Protection Rules',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          create={CreateDataProtectionRule}
          list={DataProtectionRules}
          />
        <Resource name="secure-files"
          options={{
            label: 'File Access Logs',
            breadcrumbs: [
              { label: 'SecureFile Dashboard', path: '/secure-files/dashboard' }
            ],
          }}
          list={() => <Redirect to="/secure-files/dashboard" />}
          show={SecureFileDetail}
        />
      </SecureFileComposite>

      <SimpleComposite name="performance-tuning" fallbackTo="/performance-tuning/dashboard">
        <Resource name="performance-tuning/dashboard"
          list={PerformanceTuningDashboard}
        />
      </SimpleComposite>
    </CoreAdminUI>)
  }, [permissions]);
};


export default AppRoutes;
